class Usuario{
    constructor(id, nombre, domicilio, porcentaje, tipo){
        this.id = id;
        this.nombre = nombre;
        this.domicilio = domicilio;
        this.porcentaje = porcentaje;
        this.tipo = tipo;
    }
}
export default Usuario;